module.exports = __webpack_public_path__ + "img/three_txt3.b8bba727.png";